<script type="text/ecmascript-6">
    import DesignerQuestionHardwareLetterbox from "../DesignerQuestionHardwareLetterbox.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareLetterbox,
            SynsealTileQuestion,
        ],
        computed: {
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            }
        }
    }
</script>
